const helpCodes = process.env.HELP_CODES

/* Auth */
const AuthLayout = () => import(/* webpackChunkName: "setup" */ 'components/auth/Layout.vue')
const Login = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ConnectLogin.vue')
const Logout = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/Logout.vue')
const Signup = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ConnectSignup.vue')
const ForgotPassword = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ForgotPassword.vue')
const ResetPassword = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ResetPassword.vue')
const VerifyEmail = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/VerifyEmail.vue')
const ReverseEmail = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ReverseEmail.vue')
const UnsubscribeEmail = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/UnsubscribeEmail.vue')

/* Client Connect */
const ConnectIndex = () => import(/* webpackChunkName: "clientconnect" */ 'components/connect/Home.vue')
const ConnectViewDocument = () => import(/* webpackChunkName: "clientconnect" */ 'components/connect/ViewDocument.vue')
const ConnectDocuments = () => import(/* webpackChunkName: "clientconnect" */ 'components/connect/BusinessDocuments.vue')

/* Settings */
const ClientConnectAccountDetails = () => import(/* webpackChunkName: "settings" */ 'components/connect/Settings.vue')

/* Layouts */
const ConnectLayout = () => import('components/connect/layout/Layout.vue')
const GuestCommunication = () => import('components/connect/GuestCommunication.vue')
const BlankRoute = () => import('components/statuspages/BlankRoute.vue')

/*
  Logged in:
    -1 = only logged out
     0 = either
     1 = only logged in
 */
const routes = (basePath = null) => {
  function path (url = '') {
    return `${basePath ? ('/' + basePath + '/') : '/'}${url}`
  }

  return [
    {
      path: path(),
      component: AuthLayout,
      children: [
        {
          path: '',
          name: 'ConnectSignIn',
          meta: {
            title: 'Client Connect - Sign In',
            loggedIn: -1
          },
          component: Login
        },
        {
          path: 'logout',
          name: 'ConnectSignOut',
          meta: {
            title: 'Sign Out',
            loggedIn: 0
          },
          component: Logout
        },
        {
          path: 'password/forgot',
          name: 'ConnectForgotPassword',
          meta: {
            title: 'Forgot Password',
            loggedIn: -1
          },
          component: ForgotPassword
        },
        {
          path: 'password/reset/:code?',
          name: 'ConnectResetPassword',
          meta: {
            title: 'Reset Password',
            loggedIn: -1
          },
          component: ResetPassword
        },
        {
          path: 'email/unsubscribe/:code?',
          name: 'ConnectEmailUnsubscribe',
          meta: {
            title: 'Email Unsubscribe',
            loggedIn: 0
          },
          component: UnsubscribeEmail
        },
        {
          path: 'email/verify/:code',
          name: 'ConnectVerifyEmail',
          meta: {
            title: 'Verify Email',
            loggedIn: 0
          },
          component: VerifyEmail
        },
        {
          path: 'email/reverse/:code',
          name: 'ConnectReverseEmail',
          meta: {
            title: 'Reverse Email',
            loggedIn: 0
          },
          component: ReverseEmail
        },
        {
          path: 'signup',
          name: 'ConnectSignup',
          meta: {
            title: 'Client Connect - Create Account',
            loggedIn: -1
          },
          component: Signup
        }
      ]
    },
    {
      path: path(),
      component: ConnectLayout,
      children: [
        {
          // Display all the companies the user is a client of
          path: 'home',
          name: 'ConnectIndex',
          component: ConnectIndex,
          meta: {
            title: 'Client Connect',
            loggedIn: 1,
            tags: [helpCodes.clientConnectUser]
          }
        },
        {
          path: 'business/:id(\\d+)',
          name: 'ConnectBusinessDocuments',
          meta: {
            title: 'Business',
            loggedIn: 1,
            tags: [helpCodes.clientConnectUser]
          },
          component: ConnectDocuments
        },
        {
          path: 'business/:id(\\d+)/:type/:documentId(\\d+)',
          name: 'ConnectViewDocument',
          component: ConnectViewDocument,
          meta: {
            title: 'Document',
            loggedIn: 1,
            tags: [helpCodes.clientConnectUser]
          }
        },
        {
          path: 'settings',
          name: 'ConnectProfile',
          meta: {
            title: 'Settings',
            loggedIn: 1,
            tags: [helpCodes.clientConnectUser]
          },
          component: ClientConnectAccountDetails
        }
      ]
    },
    {
      path: path(),
      component: GuestCommunication,
      children: [
        {
          path: path('accept/quotation/:referenceUrl'),
          component: BlankRoute,
          name: 'AcceptQuotation',
          meta: {
            title: 'Accept Quotation'
          }
        },
        {
          path: path('sign/report/:referenceUrl'),
          component: BlankRoute,
          name: 'SignReport',
          meta: {
            title: 'Sign Report',
            // The client signs on a bare page; the messenger sat over the signature pad
            intercom: false
          }
        },
        {
          path: path('pay/invoice/:referenceUrl'),
          component: BlankRoute,
          name: 'PayInvoice',
          meta: {
            title: 'Pay Invoice',
            intercom: false
          }
        },
        {
          path: path('refer/:referenceUrl'),
          component: BlankRoute,
          name: 'ReferClient',
          meta: {
            title: 'Link Account',
            intercom: false
          }
        },
        {
          path: path('msg/:referenceUrl'),
          component: BlankRoute,
          name: 'ViewMessage',
          meta: {
            title: 'Message Details',
            intercom: false
          }
        }
      ]
    }
  ]
}
export default routes
